import {crud} from 'app/lib/action';
import {GET_DOCS} from '../constants/actionTypes';

export default crud(GET_DOCS);